<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="800px"
      scrollable
      @keydown="executeCloseModalCreateOrUpdateAssignedArea"
      @click:outside="executeCloseModalCreateOrUpdateAssignedArea"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>
            {{ currentAssignedArea ? "Actualizar" : "Crear" }} Área Responsable
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="">
            <v-form @submit.prevent="sendUpdateOrCreateAssignedArea">
              <v-row align-content="center" class="mt-2">
                <v-col cols="12" md="12" sm="12" class="pt-0">
                  <label for="name">
                    <b> Nombre del Área Responsable * </b>
                  </label>
                  <v-text-field
                    :placeholder="`Ingresa el Nombre del Área Responsable`"
                    v-model="$v.form.name.$model"
                    :error="$v.form.name.$invalid && submitUpload"
                    :error-messages="
                      $v.form.name.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  class="pt-0"
                  v-if="activeBusinessUnits.length > 1"
                >
                  <label class="mt-1">
                    <b> Unidad de Negocio * </b>
                  </label>
                  <v-select
                    placeholder="Selecciona la Unidad de Negocio"
                    v-model="$v.form.business_unit.$model"
                    :error="$v.form.business_unit.$invalid && submitUpload"
                    :error-messages="
                      $v.form.business_unit.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                    :items="activeBusinessUnits"
                    item-text="name"
                    item-value="code"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalCreateOrUpdateAssignedArea"
          >
            <small> Cancelar </small>
          </v-btn>
          <v-btn
            @click="sendUpdateOrCreateAssignedArea"
            :color="`${currentAssignedArea ? 'warning' : 'primary'} text-white`"
            small
            class="float-right"
          >
            {{ currentAssignedArea ? "Actualizar" : "Crear" }} Área Responsable
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required } from "vuelidate/lib/validators";
import swal2 from "sweetalert2";
import { ACTIVE_BUSINESS_UNITS } from "@/constants/common";
import roles from "@/mixins/roles";

export default {
  mixins: [roles],
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalCreateOrUpdateAssignedArea: {
      type: Function,
      default: () => {},
    },
    currentAssignedArea: {
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        name: null,
        business_unit: null,
      },
      submitUpload: false,
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        business_unit:
          this.activeBusinessUnits.length == 1
            ? {}
            : {
                required,
              },
      },
    };
  },
  mounted() {
    if (this.currentUserIsSuperAdmin) {
      this.getBusinessUnits();
    } else {
      this.getBusinessUnits({
        user_email: this.user.email,
      });
    }
  },
  methods: {
    ...mapActions({
      updateOrCreateAssignedArea: "document/updateOrCreateAssignedArea",
      getBusinessUnits: "document/getBusinessUnits",
    }),
    async sendUpdateOrCreateAssignedArea() {
      let self = this;
      self.submitUpload = true;
      if (!self.$v.form.$invalid) {
        self.loading = true;
        const resp = await self.updateOrCreateAssignedArea({
          id: self.currentAssignedArea
            ? self.currentAssignedArea.id
            : undefined,
          name: self.form.name,
          business_unit_code: self.form.business_unit,
          created_by: self.user.email,
          updated_by: self.currentAssignedArea ? self.user.email : undefined,
        });
        if (resp.status == 200) {
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: self.currentAssignedArea
              ? `Área Responsable actualizada correctamente`
              : `Área Responsable creada correctamente`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("assignedAreaUpdatedOrCreated");
          this.closeModalCreateOrUpdateAssignedArea(true);
          this.resetForm();
        }
        if (!resp.status || resp.status === 400) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    executeCloseModalCreateOrUpdateAssignedArea($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalCreateOrUpdateAssignedArea($event);
      }
    },
    setAssignedArea(assignedArea) {
      this.form = {
        name: assignedArea.name,
        business_unit: assignedArea.business_unit.code,
      };
    },
    resetForm() {
      this.form = {
        name: null,
        business_unit: null,
      };
      this.submitUpload = false;
    },
    setBusinessUnitUser() {
      this.form.business_unit =
        this.activeBusinessUnits.length == 1
          ? this.activeBusinessUnits[0].code
          : null;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      businessUnits: "document/businessUnits",
    }),
    activeBusinessUnits() {
      return this.businessUnits.filter((item) =>
        ACTIVE_BUSINESS_UNITS.includes(item.name)
      );
    },
  },
  watch: {
    currentAssignedArea(newForm) {
      if (newForm) {
        this.setAssignedArea(newForm);
      } else {
        this.resetForm();
      }
    },
  },
};
</script>

<style></style>
